import { OWNERSHIPS_CACHE_ACTIONS } from '../../constants/actions';
import { ProductOwnershipResponse } from '../../types/api/OwnershipTypes';

export const setOwnershipsCache = (ownerships: { [key: number]: ProductOwnershipResponse }) => ({
  ownerships: ownerships,
  type: OWNERSHIPS_CACHE_ACTIONS.SET_OWNERSHIPS_CACHE,
});

export const addToOwnershipsCache = (ownership: ProductOwnershipResponse) => ({
  ownership: ownership,
  type: OWNERSHIPS_CACHE_ACTIONS.ADD_TO_OWNERSHIPS_CACHE,
});

export const addMultipleToOwnershipsCache = (ownerships: { [key: number ]: ProductOwnershipResponse }) => ({
  ownerships: ownerships,
  type: OWNERSHIPS_CACHE_ACTIONS.ADD_MULTIPLE_TO_OWNERSHIPS_CACHE,
});

export const addNotOwnedProductId = (productId: number) => ({
  notOwnedProductsIds: [productId],
  type: OWNERSHIPS_CACHE_ACTIONS.ADD_NOT_OWNED_PRODUCT_ID,
});
